/**
 * check if the cancellation policy ui values is invalid
 */
export function isInvalidCancellationPolicy({
  checked,
  hours,
  value,
}: {
  checked: boolean;
  hours: null | undefined | number;
  value: null | undefined | number;
}) {
  const valid =
    checked ||
    (hours !== null &&
      hours !== undefined &&
      value !== null &&
      value !== undefined);

  return !valid;
}
